import React, { FC } from 'react'
import { payPlanMobx } from '@mobx/mall/payment'
import WechatSimpleItem from './SimpleItem'

interface IProps {
  selected?: boolean;
}

const WechatPayMethodItem: FC<IProps> = ({ selected }) => {
  const amount = payPlanMobx.externalMethod?.amount
  return (
    <WechatSimpleItem selected={selected} amount={amount} onChange={() => payPlanMobx.changeExternalPayMethod('WechatPayWeb')} />
  )
}
export default WechatPayMethodItem
